import { Dialog, DialogTitle } from "@mui/material";
import { MarkJobReadyForm } from "../../MarkJobsReady/MarkJobReadyForm";
import { MarkJobReadyPopoverProps } from "./MarkJobReadyPopover.types";
import { useMarkJobReadyPopoverViewModel } from "./MarkJobReadyPopover.vm";
import "./MarkJobReadyPopover.css";

export function MarkJobReadyPopover(props: MarkJobReadyPopoverProps) {
	const viewModel = useMarkJobReadyPopoverViewModel(props);

	return (
		<Dialog fullWidth open={props.open} onClose={viewModel.handleCancel} className="mark-job-ready-popover">
			<DialogTitle>Mark Jobs Ready</DialogTitle>
			<div className="dialog-content-container">
				<MarkJobReadyForm
					{...props}
					onSubmit={viewModel.handleFormSubmit}
					onCancel={viewModel.handleCancel}
					showOnlySelectedJobs={true}
				/>
			</div>
		</Dialog>
	);
}
